export interface NavigationParams {
    integration?: string;
    violation?: string;
    resource?: string;
    policy?: string;
    platform?: string;
    playbookId?: string;
    agentStep?: string;
    finding?: string;
    stepThreadId?: string;
    issue?: string;
    preventionId?: string;
    showPrevention?: boolean;
    inLineControl?: string;
}

export enum QueryParams {
    integration = "integration",
    violation = "violation",
    resource = "resource",
    agentStep = "agentStep",
    finding = "finding",
    issue = "issue",
    stepThreadId = "stepThreadId",
    prevention = "preventionId",
    inLineControl = "inLineControl",
}
